export const MANAGE_USER_GROUP_MEMBERSHIPS_PERMISSION =
  "manage_user_group_memberships";

export const canEditUserRolesOnAdmin = (
  subdomain: string,
  permissions: readonly string[] = [],
): boolean =>
  subdomain === "admin" &&
  permissions.includes(MANAGE_USER_GROUP_MEMBERSHIPS_PERMISSION);
